import React from 'react';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import DayEntry from './DayEntry';

export default class WeekCard extends React.Component {
    render() {
        const { wjr, dateOverview } = this.props;

        return (
            <div className="card mb-3">
                <div className="card-header py-2 font-weight-bold">
                    Week Of{' '}
                    {moment(wjr.weekOfDate).format(
                        MomentDateFormat.MonthDayYearHyphensNoLeading
                    )}
                </div>
                <div className="card-body p-0">
                    {dateOverview.activeDates.map((dayOfDate, i) => (
                        <DayEntry
                            key={`${wjr.key}-${i}`}
                            wjr={wjr}
                            dayOfDate={dayOfDate}
                            i={i}
                            {...this.props}
                        />
                    ))}
                </div>
            </div>
        );
    }
}
